import React from "react";
import PropTypes from "prop-types";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import PageLayout from "../PageLayout";
import payments from "../../../assets/images/merchant-payments.webp";
import Brand from "../../../components/Brand";

/** Reference artwork surrounds the existing authentication forms and their controls. */
function IllustrationLayout({ header, title, description, children }) {
  return (
    <PageLayout>
      <SoftBox
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
          minHeight: "100dvh",
        }}
      >
        <SoftBox
          sx={({ palette }) => ({
            display: { xs: "none", lg: "flex" },
            flexDirection: "column",
            overflow: "hidden",
            backgroundColor: palette.surface.alternate,
            borderRight: "1px solid " + palette.grey[300],
            pt: 5.5,
            px: 6.25,
            backgroundImage: "radial-gradient(#d3d3c8 0.7px, transparent 0.7px)",
            backgroundSize: "20px 20px",
          })}
        >
          <Brand />
          <SoftTypography
            component="h2"
            color="dark"
            sx={({ typography }) => ({
              mt: 10,
              mb: 2.5,
              fontFamily: typography.displayFontFamily,
              fontSize: "clamp(40px, 4.8vw, 70px)",
              fontWeight: 400,
              lineHeight: 1.08,
              textTransform: "uppercase",
            })}
          >
            Your business.
            <br />
            Your payments.
            <br />
            <SoftBox
              component="span"
              sx={{
                background:
                  "linear-gradient(transparent 58%, #c6f03a 58%, #c6f03a 91%, transparent 91%)",
              }}
            >
              One place.
            </SoftBox>
          </SoftTypography>
          <SoftTypography variant="body2" sx={{ maxWidth: 340, mb: 5 }}>
            A clearer view of every transaction, every settlement, and every opportunity.
          </SoftTypography>
          <SoftBox
            component="img"
            src={payments}
            alt="Cards, currencies, and payment methods flowing through a payment gateway"
            sx={{
              width: "calc(100% + 100px)",
              maxHeight: 290,
              objectFit: "cover",
              mt: "auto",
              mx: -6.25,
              borderTop: "1px solid #0b0b0c",
            }}
          />
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            maxWidth: 460,
            mx: "auto",
            p: { xs: 3, sm: 4.5 },
            minHeight: "100dvh",
          }}
        >
          {!header ? (
            <>
              <SoftTypography
                component="h1"
                color="dark"
                sx={({ typography }) => ({
                  fontFamily: typography.displayFontFamily,
                  fontWeight: 400,
                  fontSize: { xs: 40, sm: 48 },
                  lineHeight: 1.18,
                  textTransform: "uppercase",
                  letterSpacing: "0.02em",
                })}
              >
                {title}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" sx={{ mt: 1.5, mb: 3.5 }}>
                {description}
              </SoftTypography>
            </>
          ) : (
            header
          )}
          {children}
        </SoftBox>
      </SoftBox>
    </PageLayout>
  );
}
IllustrationLayout.defaultProps = { header: "", title: "", description: "" };
IllustrationLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
};
export default IllustrationLayout;
